import TieredInterventionCallout from './component'
export default TieredInterventionCallout
